import axios from "axios";
import md5 from 'md5';
import { APP_SECRET, GETCOININFO_URL, CHANGE_URL, APP_KEY } from './../constants/PaymentApi';
import { SERVER_IP } from './../constants/Common';

export async function callGetCoinInfo(data){
    if (data.email) {
        let rs = await axios.get(`${SERVER_IP}/${GETCOININFO_URL}?email=${data.email}&sitekey=${APP_KEY}`);
        return rs.data;
    } else 
        return null;
}

export async function callChange(data){
    if (data.email && data.ordercode) {
        let params = {};
        params.email = data.email;
        params.sitekey = APP_KEY;
        params.value = data.value ? data.value : 0;
        params.checksum = md5(APP_SECRET + params.email)
        params.bonus = data.bonus ? data.bonus : 0;
        params.ordercode = 'pegatv_' + data.ordercode;
        let url = `${SERVER_IP}/${CHANGE_URL}?email=${params.email}&sitekey=${params.sitekey}&value=${params.value}&checksum=${params.checksum}&bonus=${params.bonus}&ordercode=${params.ordercode}`;
        console.log(url);
        let rs = await axios.get(url);
        return rs;
    } else 
        return null;
}


// WEBPACK FOOTER //
// ./src/helpers/ApiPayment.js